<template>
  <v-chip :color="color" dark class="semaforo-chip">
    <v-icon left>{{ icon }}</v-icon>
    {{ label }}
  </v-chip>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Semaforo',
  props: {
    meses: { type: [Number, null], required: false, default: null },
    tipoRegla: { type: String, default: 'profesionalizacion' },
    nombreVigencia: { type: String, default: '' },
    fechaVigencia: { type: String, default: '' },
  },
  computed: {
    color() {
      if (this.tipoRegla === 'desarrollo') {
        if (typeof this.meses === 'number' && this.meses > 7) return 'green'
        if (typeof this.meses === 'number' && this.meses <= 7 && this.meses >= 5) return 'yellow darken-2'
        if (typeof this.meses === 'number' && this.meses < 5 && this.meses >= 0) return 'red'
        return 'grey'
      } else {
        // profesionalizacion (regla original)
        if (typeof this.meses === 'number' && this.meses >= 0 && this.meses <= 29) return 'green'
        if (typeof this.meses === 'number' && this.meses >= 30 && this.meses <= 33) return 'yellow darken-2'
        if (typeof this.meses === 'number' && this.meses >= 34 && this.meses <= 36) return 'red'
        return 'grey'
      }
    },
    label() {
      if (this.tipoRegla === 'desarrollo') {
        if (typeof this.meses === 'number' && this.meses > 7) return 'Vigente'
        if (typeof this.meses === 'number' && this.meses <= 7 && this.meses >= 5) return 'Por vencer'
        if (typeof this.meses === 'number' && this.meses < 5 && this.meses >= 0) return 'Vencido'
        return 'Sin información'
      } else {
        if (typeof this.meses === 'number' && this.meses >= 0 && this.meses <= 29) return 'Vigente'
        if (typeof this.meses === 'number' && this.meses >= 30 && this.meses <= 33) return 'Por vencer'
        if (typeof this.meses === 'number' && this.meses >= 34 && this.meses <= 36) return 'Vencido'
        return 'Sin información'
      }
    },
    icon() {
      if (this.tipoRegla === 'desarrollo') {
        if (typeof this.meses === 'number' && this.meses > 7) return 'mdi-check-circle'
        if (typeof this.meses === 'number' && this.meses <= 7 && this.meses >= 5) return 'mdi-alert-circle'
        if (typeof this.meses === 'number' && this.meses < 5 && this.meses >= 0) return 'mdi-close-circle'
        return 'mdi-help-circle'
      } else {
        if (typeof this.meses === 'number' && this.meses >= 0 && this.meses <= 29) return 'mdi-check-circle'
        if (typeof this.meses === 'number' && this.meses >= 30 && this.meses <= 33) return 'mdi-alert-circle'
        if (typeof this.meses === 'number' && this.meses >= 34 && this.meses <= 36) return 'mdi-close-circle'
        return 'mdi-help-circle'
      }
    },
  },
  watch: {
    color(newColor, oldColor) {
      if (newColor !== oldColor) {
        this.$emit('alerta-cambio-color', newColor)
      }
    },
  },
}
</script>

<style scoped>
.semaforo-chip {
  font-size: 1rem;
  border-radius: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 0 20px;
  transition: background-color 0.5s;
}
</style>
